import { Box, Grid, Typography } from '@mui/material';
import TagsField from 'components/formik/TagsField';
import { Field } from 'formik';
import { array } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const AdditionalInfo = ({ tags = [], createTag }) => (
  <Box sx={{ pt: '20px' }}>
    <Typography variant="caption">{I18n.t('EmployeeDrawer.ADDITIONAL INFO')}</Typography>

    <Grid container>
      <Grid sx={{ display: 'flex', alignItems: 'center' }} size={2}>
        <Typography>{I18n.t('EmployeeDrawer.Tags')}</Typography>
      </Grid>
      <Grid size={10}>
        <Field name="tags" tags={tags} createTag={createTag} component={TagsField} />
      </Grid>
    </Grid>
  </Box>
);

AdditionalInfo.propTypes = {
  tags: array,
};

export default AdditionalInfo;
